import { Navigate, Routes as ReactRoutes, Route } from 'react-router-dom'
import { AuthStudent } from '@/components/auth-student'
import { AuthUser } from '@/components/auth-user'
import { ROLES } from '@/constants/roles'
import { ROUTES } from '@/constants/routes'
import { ChangeOfMajorPage } from '@/pages/change_of_major'
import { ChangeOfMajorReviewPage } from '@/pages/change-of-major-review'
import { CreditTransferPage } from '@/pages/credit_transfer'
import { CreditTransferReviewPage } from '@/pages/credit-transfer-review'
import { ExternalTransferPage } from '@/pages/external-transfer'
import { ExternalTransferReviewPage } from '@/pages/external-transfer-review'
import { GeneralRequestsPage } from '@/pages/general-requests'
import { MainManagerPage } from '@/pages/main-manager'
import { MyReviewsPage } from '@/pages/my-reviews'
import { MyReviewsChangeOfMajorPage } from '@/pages/my-reviews-change-of-major'
import { MyReviewsCreditTransferPage } from '@/pages/my-reviews-credit-transfer'
import { MyReviewsExternalTransfer } from '@/pages/my-reviews-external-transfer'
import { MyReviewsGeneralPage } from '@/pages/my-reviews-general'
import { RequestTypeChangeOfMajor } from '@/pages/request-type-change-of-major'
import { RequestTypeCreditTransferPage } from '@/pages/request-type-credit-transfer'
import { RequestTypeExternalTransferPage } from '@/pages/request-type-external-transfer'
import { SignInPage } from '@/pages/sign-in'
import { StudentChangeOfMajorPage } from '@/pages/student/change-of-major'
import { StudentCreditTransferPage } from '@/pages/student/credit-transfer'
import { ExpiredToken } from '@/pages/student/expired-token'
import { StudentExternalTransferPage } from '@/pages/student/external-transfer'
import { StudentHomePage } from '@/pages/student/home'
import { StudentMyReviews } from '@/pages/student/my-reviews'
import { StudentAuthPage } from '@/pages/student/student-auth'

export const Routes = () => {
  return (
    <ReactRoutes>
      <Route
        path="/"
        element={<Navigate to={ROUTES.SIGN_IN.route} replace />}
      />

      <Route path={ROUTES.SIGN_IN.route} element={<SignInPage />}></Route>
      <Route
        path={ROUTES.MANAGER_PANEL.route}
        element={
          <AuthUser requiredRole={ROLES.MANAGER.id}>
            <MainManagerPage />
          </AuthUser>
        }
      ></Route>
      <Route
        path={ROUTES.EXTERNAL_TRANSFER.route}
        element={
          <AuthUser>
            <ExternalTransferPage />
          </AuthUser>
        }
      ></Route>
      <Route
        path={ROUTES.STUDENT_HOME.route}
        element={
          <AuthStudent>
            <StudentHomePage />
          </AuthStudent>
        }
      />
      <Route
        path={ROUTES.STUDENT_EXTERNAL_TRANSFER.route}
        element={
          <AuthStudent>
            <StudentExternalTransferPage />
          </AuthStudent>
        }
      />
      <Route
        path={ROUTES.STUDENT_CHANGE_OF_MAJOR.route}
        element={
          <AuthStudent>
            <StudentChangeOfMajorPage />
          </AuthStudent>
        }
      />
      <Route
        path={ROUTES.STUDENT_CREDIT_TRANSFER.route}
        element={
          <AuthStudent>
            <StudentCreditTransferPage />
          </AuthStudent>
        }
      />
      <Route
        path={ROUTES.STUDENT_MY_REVIEWS.route}
        element={
          <AuthStudent>
            <StudentMyReviews />
          </AuthStudent>
        }
      />

      <Route path={ROUTES.EXPIRED_TOKEN.route} element={<ExpiredToken />} />
      <Route
        path={ROUTES.GENERAL_REQUESTS.route}
        element={
          <AuthUser requiredRole={ROLES.MANAGER.id}>
            <GeneralRequestsPage />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.MY_REVIEWS.route}
        element={
          <AuthUser requiredRole={ROLES.MANAGER.id}>
            <MyReviewsPage />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.MY_REVIEWS_CHANGE_OF_MAJOR.route}
        element={
          <AuthUser requiredRole={ROLES.MANAGER.id}>
            <MyReviewsChangeOfMajorPage />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.MY_REVIEWS_CREDIT_TRANSFER.route}
        element={
          <AuthUser requiredRole={ROLES.MANAGER.id}>
            <MyReviewsCreditTransferPage />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.MY_REVIEWS_GENERAL_REVIEWS.route}
        element={
          <AuthUser>
            <MyReviewsGeneralPage />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.CHANGE_OF_MAJOR.route}
        element={
          <AuthUser>
            <ChangeOfMajorPage />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.MY_REVIEWS_EXTERNAL_TRANSFER.route}
        element={
          <AuthUser requiredRole={ROLES.MANAGER.id}>
            <MyReviewsExternalTransfer />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.CREDIT_TRANSFER.route}
        element={
          <AuthUser>
            <CreditTransferPage />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.REQUEST_TYPES_EXTERNAL_TRANSFER.route}
        element={
          <AuthUser>
            <RequestTypeExternalTransferPage />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.REVIEW_TYPES_EXTERNAL_TRANSFER.route}
        element={
          <AuthUser>
            <ExternalTransferReviewPage />
          </AuthUser>
        }
      />

      <Route
        path={ROUTES.REQUEST_TYPES_CREDIT_TRANSFER.route}
        element={
          <AuthUser>
            <RequestTypeCreditTransferPage />
          </AuthUser>
        }
      />

      <Route
        path={ROUTES.REVIEW_TYPES_CREDIT_TRANSFER.route}
        element={
          <AuthUser>
            <CreditTransferReviewPage />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.REQUEST_TYPES_CHANGE_OF_MAJOR.route}
        element={
          <AuthUser>
            <RequestTypeChangeOfMajor />
          </AuthUser>
        }
      />
      <Route
        path={ROUTES.REVIEW_TYPES_CHANGE_OF_MAJOR.route}
        element={
          <AuthUser>
            <ChangeOfMajorReviewPage />
          </AuthUser>
        }
      />
      <Route path={ROUTES.STUDENT_AUTH.route} element={<StudentAuthPage />} />
    </ReactRoutes>
  )
}
